import React, { memo } from 'react';
import { formatOracleDateToBr } from '../../../../../../services/funcoes';
import { Button, Icon } from 'react-materialize';

export const Card = memo(({ prod, handleAddProductConsignado, handleAddProduct }) => {

  return (
    <div
      className="card"
      style={{
        height: '200px',
        fontSize: '16px',
        borderRadius: '5px',
        border: '1px solid #9545ba',
        boxShadow:
          'rgba(0, 0, 0, 0.25) 0px 2px 2px, rgba(0, 0, 0, 0.12) 0px 0px 3px, rgba(0, 0, 0, 0.12) 0px 2px 2px, rgba(0, 0, 0, 0.17) 0px 4px 3px, rgba(0, 0, 0, 0.09) 0px 0px 2px',
      }}
    >
      <div
        style={{
          width: '100%',
          background: '#8E44AD',
          borderRadius: '5px 5px 0px 0px',
          padding: '4px',
        }}
      >
        <span style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '700' }}>
          {prod.PROD_DESCR
            ? `${prod.PROD_DESCR} - ${prod.LOTE} / ${prod.SERIE}`
            : `${prod.NOME_FANTASIA} - ${prod.RAZAO_SOCIAL}`}
        </span>
      </div>
      <p style={{ padding: '0 0.2rem', fontWeight: '700', fontSize: '1rem' }}>
        {prod.CODIGO_INTEGRACAOO || prod.PROD_CODIGO} - {prod.PRODUTO || prod.PROD_DESCR}
      </p>
      <p style={{ padding: '0 0.2rem', fontSize: '1rem' }}>
        Endereço: {prod.ENDERECO} - {prod.CIDADE} - {prod.UF}
      </p>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '0.6rem',
          padding: '0 0.2rem',
          fontSize: '1rem',
        }}
      >
        <p>
          <strong>Armazém: </strong>
          {prod.ESIN_ARMAZEM || 'N/A'}
        </p>
        <p>
          <strong>Lote: </strong>
          {prod.LOTE}
        </p>
        <p>
          <strong>Série: </strong>
          {prod.SERIE}
        </p>
      </div>
      <p style={{ padding: '0 0.2rem', fontSize: '1rem' }}>
        <strong>Qtde:</strong> {prod.QTDE - prod.QTDE_UTILIZADA}
      </p>
      {prod.CONTATO && (
        <p style={{ padding: '0 0.2rem', fontSize: '1rem' }}>
          <strong>Contato:</strong> {prod.CONTATO}
        </p>
      )}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '0.6rem',
          padding: '0 0.2rem',
          fontSize: '1rem',
        }}
      >
        <p>
          <strong>Validade: </strong>
          {formatOracleDateToBr(prod.DATA_VALIDADE)}
        </p>
        <p style={{ color: prod.LOCALIZACAO === 'CONSIGNADO' ? '#ed3241' : '#14532d', fontWeight: '600' }}>
          {prod?.LOCALIZACAO?.replaceAll('_', ' ') || 'CONSIGNADO'}
        </p>
      </div>
      <Button
        onClick={() => {
          if (prod.PROD_DESCR) {
            handleAddProductConsignado(prod);
          } else {
            handleAddProduct(prod);
          }
        }}
        style={{
          gap: '0.3rem',
          margin: '0.6rem 0.2rem 0.2rem',
          width: '98%',
        }}
        className="waves-effect waves-light saib-button is-primary"
      >
        Adicionar no pedido
        <Icon className="modal-close">add</Icon>
      </Button>
    </div>
  );
});
